import { render } from "./MainSidebarItemIcon.vue?vue&type=template&id=a207758c"
import script from "./MainSidebarItemIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSidebarItemIcon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/layout/MainSidebarItemIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a207758c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a207758c', __exports__)) {
    api.reload('a207758c', __exports__)
  }
  
  module.hot.accept("./MainSidebarItemIcon.vue?vue&type=template&id=a207758c", () => {
    api.rerender('a207758c', render)
  })

}


export default __exports__